import LogsPage from './history-page';

export default function GroupLogsPage() {
  return <LogsPage />;
}
